import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { mutateCart, refreshCart, syncCartControls } from '@theme/cart-sync';
import { cartPerformance } from '@theme/performance';

class CartItemsComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    document.addEventListener(ThemeEvents.discountUpdate, this.#handleCartUpdate);
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#onQuantityChange);
    syncCartControls();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    document.removeEventListener(ThemeEvents.discountUpdate, this.#handleCartUpdate);
    document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#onQuantityChange);
  }

  #onQuantityChange = event => {
    // Both drawer and full-cart components can be mounted. Only the originating
    // component may send a mutation, otherwise a promotion split can shift lines.
    if (!(event.target instanceof Element) || event.target.closest('cart-items-component') !== this) return;
    const { quantity, cartLine: line } = event.detail;
    if (line) void this.updateQuantity({ line, quantity, action: 'change' });
  };

  onLineItemRemove(line) {
    // Keep the item visible until Shopify confirms removal.
    return this.updateQuantity({ line, quantity: 0, action: 'clear' });
  }

  async updateQuantity({ line, quantity, action }) {
    const marker = cartPerformance.createStartingMarker(`${action}:user-action`);
    try { await mutateCart(Theme.routes.cart_change_url, { line, quantity }); }
    finally { cartPerformance.measureFromMarker(marker); }
  }

  #handleCartUpdate = event => {
    if (event.detail?.data?.cartRendered) return;
    // One shared refresh updates every cart surface and catches rendering errors.
    if (document.querySelector('cart-items-component') === this) void refreshCart();
  };
}

if (!customElements.get('cart-items-component')) customElements.define('cart-items-component', CartItemsComponent);
